import { ChangeDetectorRef, Component, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AngularResizeElementDirection, AngularResizeElementEvent } from 'angular-resize-element';
import { Subscription } from 'rxjs';
import { BookmarkService } from './bookmark.service';
import { ApiService } from 'src/app/services/api.service';
import { ActivatedRoute } from '@angular/router';
import { NavigationService } from 'src/app/services/navigation.service';
import moment from 'moment';
import { FilterService } from 'src/app/services/filter.service';
import { HttpClient } from '@angular/common/http';
import { DashboardService } from 'src/app/services/dashboard.service';
import { MatDialog } from '@angular/material/dialog';
import { PopupDeleteComponent } from '../popup-delete/popup-delete.component';
import { ShareByBookmarkComponent } from './share-by-bookmark/share-by-bookmark.component';
import _ from 'lodash';

@Component({
  selector: 'app-bookmark-view',
  templateUrl: './bookmark-view.component.html',
  styleUrls: ['./bookmark-view.component.scss']
})
export class BookmarkViewComponent implements OnInit, OnChanges {

  @Input("offcanvasRightBookmarkView") offcanvasRightBookmarkView:any;
  @Input("bookmarkIndication") bookmarkIndication:any;
  
  @Output("onResizeSideWindow") onResizeSideWindow = new EventEmitter<any>();
  
  public readonly AngularResizeElementDirection = AngularResizeElementDirection;
  public data: any = {};
  reqSubcription: Subscription[] = [];
  employee_key:any;
  allBookmarkData:any;
  groupedData:any;
  loadApidata = false;
  jsonIconData:any;
  dashboardKey:any;
  selectedDashboardKey:any;
  pageIdx:any = 0;
  moment=moment;
  bookMarkName:any;
  tabId:any;
  bookmarkSearchText:any;
  sort: any = 'desc';
  bookmarkId:any;

  constructor(
    private bookmarkService: BookmarkService,
    private apiService: ApiService,
    private router: ActivatedRoute,
    private navigationService: NavigationService,
    private filterService: FilterService,
    private httpClient: HttpClient,
    private dashboardService: DashboardService,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog
  ) { 
    this.router.params.subscribe((p: any) => {
      this.bookmarkId = p?.['bk_mrk_key'] || undefined;
      // Query Params
      this.router.queryParams.subscribe((params:any) => {
        let decryptedParams = this.navigationService.decryptData(params);
        // this.moduleKey = decryptedParams["md_key"];
        this.dashboardKey = decryptedParams["ds_key"];
        this.selectedDashboardKey = this.dashboardKey;
        this.tabId = params["tab_id"] || 0;
      })
    })
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['bookmarkIndication'].currentValue != changes['bookmarkIndication'].previousValue) {
      this.loadApidata = false;
      let empkey = sessionStorage.getItem('employee_key');
      if (empkey) {
        const parsedEmpkey: any = JSON.parse(empkey);
        this.employee_key = parsedEmpkey._value;
      }
      this.loadApidata = false;
      this.loadLocalIcon();
    }
  }

  public onResizeSide(evt: AngularResizeElementEvent): void {
    this.data.width = evt.currentWidthValue;
    this.data.height = evt.currentHeightValue;
    this.data.top = evt.currentTopValue;
    this.data.left = evt.currentLeftValue;
    this.onResizeSideWindow.emit(this.data);
  }

  @HostListener("window:resize", ["$event"])
  onResize(event: Event) {
    this.checkOrientation();
  }

  checkOrientation() {
    this.data.width = 320;
    this.onResizeSideWindow.emit(this.data);
  }

  loadLocalIcon() {
    this.apiService.getDoc("module-icon").subscribe((data: any) => {
      this.jsonIconData = data;
      this.getBookMarkDetails();
    });
  }

  getGroupByModule(data:any) {
    // Find the icon using local json  
    data = data.map((m:any)=> {
      if(this.jsonIconData?.length>0) {
        let fndIcon = this.jsonIconData.find((f:any)=> f.module_key == m.module_key);
        return {...m, module_icon: fndIcon?.icon}
      }
      return {...m, module_icon: ""}
    })

    // API data
    this.groupedData = this.bookmarkService.aggBookmarkByDashboard(data, this.dashboardKey)
    this.loadApidata = true; 
  }

  openExpansionPanel(page:any, pageIdx:any) {
    if(this.bookmarkSearchText) return;
    if(pageIdx==this.pageIdx) return;
    this.pageIdx = pageIdx;
    this.sort='desc';
    this.selectedDashboardKey = page.dashboard_key;
    this.orderBy(this.sort, page, pageIdx)
  }

  getBookMarkDetails() {
    if (this.isEmptyObject(this.filterService.baseQuery) == false) {
      let obj: any = {
        "brand_key" : this.filterService?.baseQuery?.brand_key,
        "module_key": this.dashboardService.moduleKey
      }
      let widgetEndpoint = 'api/bookmarks/get-employee-bookmarks';
      this.reqSubcription.push(this.bookmarkService.bookMarkQuery(obj, widgetEndpoint).subscribe((res: any) => {
        let responseData = res ? res : [];
        responseData = _.orderBy(responseData, [(message:any) => new Date(message.insert_timestamp)], this.sort);
        this.allBookmarkData = this.formatData(responseData);
        this.getGroupByModule(this.allBookmarkData);
        this.unreadMergeApi();
      }, (err:any) => {
        this.loadApidata = true;
        console.log('Issue in Bookmart Insertion',err)
      }));
    }
  }

  insertTimeOut = false;

  formatData(responseData:any) {
    const updatedResponseData = responseData.map((m: any) => {
      if(m.bookmark_value) {
        m.bookmark_value = JSON.parse(m.bookmark_value);
        m["flr_count"] = m.bookmark_value.flr_count || 0
        m["insertDate"] = moment(m.insert_timestamp).format('MM-DD-YYYY')  || ""
        m["insertTime"] = moment(m.insert_timestamp).format('hh:mm A') || ""
      }

      if (m.bookmark_url) {
        const splt = m.bookmark_url.split('?');
        if (splt.length > 1) {
          const query = splt[1].split('&');
          const queryParams: any = {};

          query.forEach((param: string) => {
            const [key, value] = param.split('=');
            if (key && value) {
              queryParams[decodeURIComponent(key)] = decodeURIComponent(value);
            }
          });

          let decryptedParams:any = this.navigationService.decryptData(queryParams);
          // decryptedParams['bk_mrk_id'] = m.bookmark_key || 0

          // Attach decryptedParams to the original object
          return {
            ...m,
            decryptedParams,
          };
        }
      }
      
      // Return the original object if no bookmark_url or query
      return m;
    });

    return updatedResponseData;
  }

  insertBookmark($event:any) {
    $event.preventDefault();

    if(!this.insertTimeOut) {
      this.insertTimeOut = true;
      setTimeout(() => {
        this.insertTimeOut = false;
      }, 2000);

      if (this.isEmptyObject(this.filterService.baseQuery) == false && this.bookMarkName) {
        // Get new object from base query
        let flrBadge = this.filterService.badges.filter((f:any) => f.showBy != 'no');
        let flrValue:any = Object.assign({}, this.filterService?.baseQuery, {flr_count: flrBadge.length, show_by: this.filterService.showByKey})
        let flrFormlyFilter = this.filterService.badges.filter((f:any) => f.path === "formlyDateRangeSelection");
        let flrFormlyYearlyFilter = this.filterService.badges.filter((f:any) => f.path === "formlyYearlySelection");

        flrValue["carry_date_filter"] = false;
        // find all the date filter where are all hardcoded and make it as True
        let dateFilterHardCodedKey = ['quarter_select', 'date_range', 'quarter_range_select', 'time_date', 'time_single_date'];
        let ifQuery: any = this.filterService?.badges.find((fnd: any) => dateFilterHardCodedKey.some((res: any) => res == fnd.key));
        if(ifQuery && this.filterService.allDefaultDate && Object.keys(this.filterService.allDefaultDate).length>0) {
          let frmDt = this.filterService.allDefaultDate['from_date'];
          let toDt = this.filterService.allDefaultDate['to_date'];

          if(moment(ifQuery?.selectedData?.from_date).format('MM-DD-YYYY')  == frmDt && moment(ifQuery?.selectedData?.to_date).format('MM-DD-YYYY') == toDt) {
            flrValue["carry_date_filter"] = false;
            flrValue['flr_count'] -= 1
          } else {
            flrValue["carry_date_filter"] = true;
          }
        }

        // Formly Form Dynamic Date filter
        if (this.filterService.allDefaultDate?.['formly_date']?.length > 0 && flrFormlyFilter?.length > 0) {
          let allDefault = this.filterService.allDefaultDate['formly_date'] || [];
          flrValue["carry_formly_date_filter"] = [];
          flrFormlyFilter.forEach((e: any) => {
            let fndFormlyField = allDefault.find((f: any) => f.key === e.key);

            if (fndFormlyField && e?.selectedData && Object.keys(e.selectedData).length > 0) {
              let { start, end } = e.selectedData;
              let frmDt = fndFormlyField['from_date']; // formatted as 'MM-DD-YYYY'
              let toDt = fndFormlyField['to_date'];   // formatted as 'MM-DD-YYYY'

              const formattedStart = start ? moment(start).format('MM-DD-YYYY') : null;
              const formattedEnd = end ? moment(end).format('MM-DD-YYYY') : null;

              const bothNull = !formattedStart && !frmDt && !formattedEnd && !toDt;
              const bothSame = formattedStart === frmDt && formattedEnd === toDt;

              if (bothNull || bothSame) {
                flrValue["carry_formly_date_filter"].push({ key: e.key, selected: false });
                flrValue['flr_count'] -= 1;
              } else {
                flrValue["carry_formly_date_filter"].push({
                  key: e.key,
                  selected: true,
                  start: moment(start).format('MM-DD-YYYY'),
                  end: moment(end).format('MM-DD-YYYY')
                });
              }
            } else {
              flrValue["carry_formly_date_filter"].push({ key: e.key, selected: false });
              flrValue['flr_count'] -= 1;
            }
          });

          flrValue["carry_formly_date_filter"] = JSON.stringify(flrValue["carry_formly_date_filter"]);
        }
        
        // Formly Form Dynamic Yearly filter
        if (this.filterService.allDefaultDate?.['formly_yearly_selection']?.length > 0 && flrFormlyYearlyFilter?.length > 0) {
          let allDefault = this.filterService.allDefaultDate['formly_yearly_selection'] || [];
          flrValue["carry_formly_year_filter"] = [];
          flrFormlyYearlyFilter.forEach((e: any) => {
            let fndFormlyField = allDefault.find((f: any) => f.key === e.key);

            if (fndFormlyField && e?.selectedData && Object.keys(e.selectedData).length > 0) {
              let selectedDate = e.selectedData?.start || null;
              let frmDt = fndFormlyField['selectedDate'];
              const formattedStart = selectedDate ? moment(selectedDate).format('YYYY') : null;
              
              const bothSame = formattedStart === frmDt 
              const bothNull = !formattedStart && !frmDt

              if (bothNull || bothSame) {
                flrValue["carry_formly_year_filter"].push({ key: e.key, selected: false });
                flrValue['flr_count'] -= 1;
              } else {
                flrValue["carry_formly_year_filter"].push({
                  key: e.key,
                  selected: true,
                  selectedDate: moment(formattedStart).format('YYYY'),
                });
              }
            } else {
              flrValue["carry_formly_year_filter"].push({ key: e.key, selected: false });
              flrValue['flr_count'] -= 1;
            }
          });

          flrValue["carry_formly_year_filter"] = JSON.stringify(flrValue["carry_formly_year_filter"]);
        }

        const sessionItem = [
          "navDetailInfo", "detailConfig", "filterData", "payloadData", "dashboardControl", 
          "SelectedStatus", "source_patient_id", "navbar_prName", "navHeaderData", "patDataStatusChange"
        ];

        // let setItemForUserState = this.filterService.badges
        //   .filter((f: any) => ['singleSelection', 'multiSelection', 'newMultiSelection'].includes(f.type))
        //   .map((f: any) => f.key)
        //   .join(', ');
        
        // flrValue['setItemForUserState'] = setItemForUserState
        
          const getMatchingSessionData = () => {
          const result: { [key: string]: any } = {};
          sessionItem.forEach((key) => {
            let value:any = sessionStorage.getItem(key);
            if (value !== null) {
              result[key] = value;
            }
          });
          return result;
        };

        const matchedSessionData = getMatchingSessionData();
        flrValue['sessionStored'] = JSON.stringify(matchedSessionData)
        // console.log(matchedSessionData);

        // let setItemForUserState = this.filterService.badges
        //   .filter((f: any) => ['singleSelection', 'multiSelection', 'newMultiSelection'].includes(f.path))
        //   .map((f: any) => f.key)
        //   .join(', ');
        
        const findAndMakeNullable = (flrKey: any) => {
        let all = this.filterService?.allOptionData?.multi || {};
        let select = this.filterService?.selectedItem?.multi || {};

        for (const key in all) {
          if (key === flrKey) {
            const allValues = all[key];
            const selectedValues = select[key] || [];

            if (selectedValues.length === allValues.length && selectedValues.length > 0) {
              flrValue[key] = null;

              const otherKeys = Object.keys(selectedValues[0]).filter((k) => k !== key);
              let addParam = this.filterService?.duplicateParameter || {};

              const dd = otherKeys.find((innerKey: any) => Object.keys(addParam).includes(innerKey));

              if (dd) {
                flrValue[dd] = null;
              }
            }
          }
        }
      };

      // Now loop through badges
      this.filterService.badges.forEach((f: any) => {
        if (f.path === 'multiSelection' || f.path === 'newMultiSelection') {
          findAndMakeNullable(f.key);
        }
      });

        
        let cleanUrl = this.findURL();

        let obj: any = {
          "bookmark_name": this.bookMarkName || '',
          "brand_key" : this.filterService?.baseQuery?.brand_key,
          "module_key": this.dashboardService.moduleKey,
          "dashboard_key" : this.dashboardKey,
          "page_key" : this.dashboardService.getPageKey[Number(this.tabId)],
          "bookmark_value": flrValue,
          "bookmark_url": cleanUrl || "",
        }
        let widgetEndpoint = 'api/bookmarks/insert-employee-bookmark';
        this.reqSubcription.push(this.bookmarkService.bookMarkQuery(obj, widgetEndpoint).subscribe((res: any) => {
          if(res) {
            this.bookMarkName = "";
            this.getBookMarkDetails();
          } else {
            console.log("Bookmark insert is failing")
          }
        }, (err:any) => {
          // this.dialogService.customSnackBar('error', 'red', 'Error Message');
          console.log('Issue in Bookmart Insertion',err)
        }));
      }
    }
  }

  findURL() {
    const currentUrl:any = this.navigationService?.['router']?.url;
    const routePath = this.router.routeConfig?.path;
    let cleanUrl = currentUrl;
    if (routePath?.includes(':bk_mrk_key')) {
      // Remove the last path segment (assumed to be the bookmark key)
      const [path, query = ''] = currentUrl.split('?');
      const segments = path.split('/');

      // Remove the last segment (assumed bk_mrk_key)
      segments.pop();

      const cleanedPath = segments.join('/');
      return query ? `${cleanedPath}?${query}` : cleanedPath;
    }

    return cleanUrl
  }

  isEmptyObject(obj: any) {
    return Object.keys(obj).length === 0;
  }

  navigateBtn(innerGroup:any) {
    if(this.bookmarkId == innerGroup.bookmark_key) return;
    // debugger
    this.filterService.resetFilter();
    let dashboardDetail = {
      dashboard_nm: innerGroup.dashboard_nm,
      work_nm: innerGroup.work_nm,
      dashboard_key: innerGroup.dashboard_key
    }
    let session = innerGroup?.bookmark_value || ''
    if(session?.sessionStored) {
      let json = JSON.parse(session?.sessionStored);
      if(Object.keys(json).length>0) {
        for (const key in json) {
          const value = json[key];
          sessionStorage.setItem(key, value);
        }
      }
    }
    sessionStorage.setItem("navbar_page_nm", JSON.stringify(dashboardDetail))

    const splt = innerGroup?.bookmark_url.split('?');
    if (splt.length > 1) {
      const strQuery = splt[0]+'/'+ innerGroup.bookmark_key;
      let queryMaped = this.navigationService.movePropertyToFirst(innerGroup.decryptedParams, 'tab_id');

      if(this.dashboardService.menuItems?.length>0 && queryMaped.md_key) {
      let fndModule = this.dashboardService.menuItems.find((f:any) => f.access_flg == "Y" && queryMaped.md_key == f.module_key);
      if(fndModule) {
        this.dashboardService.userMenuModuleHandle(false, fndModule);
      }
    }

      this.navigationService.routerNavigate(`${strQuery}`, queryMaped);
    }
  }

  editIdx:any;
  editBookmarkName:any;

  bookmarkRename(innerGroup:any, idx:any, i:any) {
    this.editIdx = idx+''+i
    this.editBookmarkName = innerGroup.bookmark_name || '';
  }
  
  bookmarkShare(innerGroup:any, idx:any, i:any) {
    this.dialog.closeAll();

    let dialogRef = this.dialog.open(ShareByBookmarkComponent, {
      width: this.getResponsiveDialogWidth(),
      height: '70vh',
      disableClose: true,
      panelClass: ["du-custom-modalbox", "du-share-bookmark-dialog"],
      data: {
        bookmark: innerGroup,
        idx: idx,
        i: i,
        employee_key: this.employee_key
      }
    });

    dialogRef.afterClosed().subscribe((value) => {
      console.log(value)
    });

  }

  getResponsiveDialogWidth(): string {
    const width = window.innerWidth;

    if (width <= 600) {
      // Mobile
      return '90vw';
    } else if (width <= 960) {
      // Tablet
      return '60vw';
    } else {
      // Desktop
      return '25vw';
    }
  }

  bookmarkDelete(innerGroup:any, idx:any, i:any) {
    
    this.dialog.closeAll();

    let dialogRef = this.dialog.open(PopupDeleteComponent, {
      maxWidth: '90vw',
      disableClose: true,
      panelClass: "du-custom-modalbox",
      data:'Bookmark'
    });

    dialogRef.afterClosed().subscribe((value) => {
      if(value == '1') {
        let fndObj = this.groupedData[idx].bookmarks[i];
        if(!fndObj) return;
        this.deleteCommentApi(fndObj?.bookmark_key, idx, i)
      }
    }); 
  }

  deleteCommentApi(key:any, idx:any, i:any) {
    let obj = { "bookmark_key" : key || '' };
    let renameEndpoint = "api/bookmarks/delete-employee-bookmark";
    this.reqSubcription.push(this.bookmarkService.bookMarkUpdateQuery(obj, renameEndpoint).subscribe((res: any) => {
        this.getBookMarkDetails();
        // let findSplice = this.groupedData[idx].bookmarks.splice(i, 1);
        // if (findSplice.length > 0) {
        //   let decrease = findSplice[0].is_new == 'Y';
        //   if (decrease) {
        //     this.groupedData[idx].unread_bookmark -= 1;
        //   }

        //   // If no more bookmarks, remove the entire group
        //   // if (this.groupedData[idx].bookmarks.length === 0) {
        //   //   this.groupedData.splice(idx, 1);  // <-- FIXED: Use splice, not slice
        //   // }
        // }
        // this.cdr.detectChanges();
    }, (err:any) => {
      if(err.status == 200) {
        this.getBookMarkDetails();
        // let findSplice = this.groupedData[idx].bookmarks.splice(i, 1);
        // if (findSplice.length > 0) {
        //   let decrease = findSplice[0].is_new == 'Y';
        //   if (decrease) {
        //     this.groupedData[idx].unread_bookmark -= 1;
        //   }

        //   // If no more bookmarks, remove the entire group
        //   // if (this.groupedData[idx].bookmarks.length === 0) {
        //   //   this.groupedData.splice(idx, 1);  // <-- FIXED: Use splice, not slice
        //   // }
        // }
        // this.cdr.detectChanges();
      }
      console.log('Issue in Bookmark Delete',err)
    }));
  }

  loadRenameApiData(idx:any, i:any) {
    if(!this.editBookmarkName) return;
    let fndObj = this.groupedData[idx].bookmarks[i];
    if(!fndObj) return;
    fndObj.bookmark_name = this.editBookmarkName;
    this.editIdx = undefined;
    let obj = {
      "bookmark_key" : fndObj?.bookmark_key || '',
      "bookmark_name": fndObj.bookmark_name || ""
    }
    let renameEndpoint = "api/bookmarks/update-employee-bookmark"
    this.reqSubcription.push(this.bookmarkService.bookMarkUpdateQuery(obj, renameEndpoint).subscribe((res: any) => {
        
    }, (err:any) => {
      console.log('Issue in Bookmark update',err)
    }));
  }
  
  unreadMergeApi() {
    let obj: any = {
      "brand_key" : this.filterService?.baseQuery?.brand_key,
      "module_key": this.dashboardService.moduleKey
    }
    this.reqSubcription.push(this.bookmarkService.unreadMergeApi(obj).subscribe((res: any) => {
    }, (err:any) => {
      console.log('Issue in Bookmark update',err)
    }));
  }

  onFilterTextBoxChanged(flag?:any) { 
    const filterKeys = ["bookmark_name", "dashboard_nm", "flr_count", "insertDate", "insertTime"];
    const messagesToGroup = this.bookmarkSearchText ? this.bookmarkService.filterBookmarkByKeys(this.allBookmarkData, filterKeys, this.bookmarkSearchText) : this.allBookmarkData;
    this.getGroupByModule(messagesToGroup);
  }

  orderBy(order:any, page:any, idx:any) {
    this.sort = order;
    if(this.groupedData?.[idx]?.bookmarks?.length>0) {
      this.groupedData[idx].bookmarks = _.orderBy(this.groupedData[idx].bookmarks, [(message:any) => new Date(message.insert_timestamp)], this.sort);
    }
  }

  trackByFnMessage(index: number): number {
    return index;
  }

  ngOnDestroy(): void {
    this.reqSubcription.forEach(res => res.unsubscribe())
  }
}
